import { render, staticRenderFns } from "./platformMobile.vue?vue&type=template&id=4024e060&"
import script from "./platformMobile.vue?vue&type=script&lang=js&"
export * from "./platformMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports